import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconZoomIn({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconZoomIn, className)}
			{...props}
		>
			<path
				d="M97.0605 50C97.0603 24.0101 75.9899 2.93952 50 2.93952C24.0102 2.93967 2.93967 24.0102 2.93952 50C2.93952 75.9899 24.0101 97.0603 50 97.0605V100L47.4262 99.9344C21.8605 98.6379 1.36187 78.1396 0.0656353 52.5738L0 50C0.00014351 22.3858 22.3858 0.000143515 50 0L52.5738 0.0656353C78.9921 1.40509 99.9999 23.2489 100 50L99.9344 52.5738C98.5949 78.9922 76.7512 100 50 100V97.0605C75.99 97.0605 97.0605 75.99 97.0605 50Z"
			/>
			<path
				d="M53.8728 75.9978L47.9891 75.9978L47.9891 23.9962L53.8728 23.9962L53.8728 75.9978Z"
			/>
			<path
				d="M24.0042 53.8788L24.0042 47.9951L76.0058 47.9951L76.0058 53.8788L24.0042 53.8788Z"
			/>
		</SvgIcon>
	)
}
